import * as React from 'react';
import {RouteComponentProps} from 'react-router';
import * as Glob from '../Globale';

export class Home extends React.Component<Glob.IRouteGlobaleProps, {}> {
    constructor(props: any) {
        super(props);

        location.replace("/login");
    }

    public render() {
        return <br/>;
    }
}




// WEBPACK FOOTER //
// ./src/layout/Home.tsx